import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getAccessToken } from '@/auth';
import { OAUTH_LOGIN_HOST } from '@/constants/common';

export default function OAuth() {
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);
  const migration = searchParams.get('migration');
  const redirect = searchParams.get('redirect');
  const code = searchParams.get('code');
  const isMigrationCompleted = migration === 'true';

  useEffect(() => {
    (async () => {
      // OAuth 인증 후 돌아온 경우 (code 파라미터가 있음)
      if (code) {
        const redirectParam = redirect ? `&redirect=${encodeURIComponent(redirect)}` : '';
        window.location.href = `/auth/loginCallback?code=${code}${redirectParam}`;
        return;
      }

      const accessToken = await getAccessToken();

      if (accessToken) {
        history.push(redirect || '/apps');
        return;
      }

      // OAuth 서버로 리다이렉트 (redirectUrl을 /auth/login?redirect=...로 설정)
      const loginUrl = redirect
        ? `${window.location.origin}/auth/login?redirect=${encodeURIComponent(redirect)}`
        : `${window.location.origin}/auth/login`;
      const oauthLoginUri = `https://${OAUTH_LOGIN_HOST}/auth/signin?redirectUrl=${encodeURIComponent(
        loginUrl
      )}&referrer=studio`;

      if (isMigrationCompleted) {
        window.location.href = `${oauthLoginUri}&migration=true`;
      } else {
        window.location.href = oauthLoginUri;
      }
    })();
  }, [code, redirect, history]);

  return null;
}
